import { Center, Flex, Text, useMantineTheme } from "@mantine/core";

interface IProps {
  title: string;
  hasOverlay?: boolean;
  children: React.ReactNode;
}

const BigHeader = ({ title, hasOverlay = false, children }: IProps) => {
  const theme = useMantineTheme();

  return (
    <Flex
      h="fit-content"
      direction="column"
      w="100%"
      justify={"center"}
      align={"center"}
      bg={{
        base: `linear-gradient(180deg, ${theme.colors.other[3]} 90px, ${theme.colors.other[0]} 90px)`,
        991: `linear-gradient(180deg,${theme.colors.other[3]}  150px, ${theme.colors.other[0]} 150px)`,
      }}
      px={{ base: 24, 991: 60 }}
    >
      <Flex
        h="fit-content"
        w="100%"
        id={title}
        justify={"center"}
        bg={theme.colors.other[3]}
      >
        <Center h={{ base: 90, 991: 150 }} mb={"unset"} maw={1680} w="100%">
          <Text
            fw={700}
            fz={{ base: "40px", 991: "9.5vw", 1920: 150 }}
            lh={"100%"}
            sx={{
              whiteSpace: "nowrap",
              background: `linear-gradient(180deg, ${theme.colors.basic[0]} -50%, rgba(255, 255, 255, 0) 85%)`,
              backgroundClip: "text",
              textFillColor: "transparent",
            }}
          >
            {title}
          </Text>
        </Center>
      </Flex>
      <Flex
        direction="column"
        maw={1680}
        w="100%"
        mt={hasOverlay ? { base: -32, 991: -50 } : "unset"}
      >
        {children}
      </Flex>
    </Flex>
  );
};

export default BigHeader;
